export default function FloorMapSkeleton() {
  return (
    <div className="p-6 w-full max-w-300 mx-auto animate-pulse">
      {/* Header */}
      <div className="mb-6 space-y-2">
        <div className="h-6 w-40 bg-gray-200 rounded" />
        <div className="h-4 w-96 bg-gray-200 rounded" />
      </div>

      {/* Legend */}
      <div className="flex gap-4 mb-4">
        <div className="flex items-center gap-2">
          <div className="h-3 w-3 bg-gray-300 rounded" />
          <div className="h-3 w-24 bg-gray-200 rounded" />
        </div>
        <div className="flex items-center gap-2">
          <div className="h-3 w-3 bg-gray-300 rounded" />
          <div className="h-3 w-20 bg-gray-200 rounded" />
        </div>
      </div>

      {/* Floor Map Image Placeholder */}
      <div className="w-full max-w-7xl md:max-w-218.75 m-auto">
        <div className="relative w-full overflow-hidden rounded-lg bg-gray-200">
          {/* keeps aspect ratio similar to image */}
          <div className="pt-[56%]" />
        </div>

        <div className="mt-2 flex justify-center">
          <div className="h-3 w-96 bg-gray-200 rounded" />
        </div>
      </div>
    </div>
  )
}
